// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + "e8f0f1fa" + ".css";
};